<template>    
    <div class="py-4 container-fluid">
        <div class="row">
            <div class="col-lg-6">                  
                <div class="row mb-5">                    
                    <div class="col-lg-12 mt-lg-0 mt-4">
                        <user-manual-type-detail />                        
                    </div>
                </div>
            </div>
        </div>
        <div class="row"></div>
    </div>        
</template>

<script>
import UserManualTypeDetail from "./components/UserManualTypeDetail.vue"

export default {
    name: 'UserManualType_edit_page',
    components: {        
        UserManualTypeDetail
    },
    data() {
        return {
            Id: '',
            usermanualtype: [],
            gets: []
        }
    },
    async mounted() {
        this.id = this.$route.params.id;   
        console.log('Route ID:', this.id);   
    },
}
</script>